import { RefObject, useEffect, useRef } from 'react';

/**
 * Moves keyboard focus to the returned element when it appears, so the
 * control that was pressed disappearing does not drop focus back to the body.
 * The element needs `tabIndex={-1}` to be focusable.
 *
 * @param enabled - Whether this appearance should take focus; a screen
 *   reached by opening the link should not.
 */
export const useFocusOnMount = <T extends HTMLElement>(
  enabled: boolean
): RefObject<T> => {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (enabled) {
      ref.current?.focus();
    }
  }, [enabled]);

  return ref;
};
